import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, CheckCircle2 } from 'lucide-react';
import { Badge } from '../components/ui/badge';
import { updates } from '../data/mock';

export const BlogPage = () => {
  return (
    <div className="min-h-screen bg-dark-primary py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Button */}
        <Link to="/" className="inline-flex items-center text-purple-light hover:text-purple-primary transition-colors mb-8">
          <ArrowLeft className="mr-2" size={20} />
          Voltar para Home
        </Link>

        {/* Page Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-bold font-archive text-white mb-4 glow-text">
            Notas de Atualização
          </h1>
          <p className="text-xl text-gray-400 font-hero max-w-2xl mx-auto">
            Acompanhe as últimas melhorias e novidades da plataforma Gameodys
          </p>
        </div>

        {/* Updates Timeline */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-purple-primary via-green-primary to-purple-primary"></div>

            {/* Updates */}
            <div className="space-y-12">
              {updates.map((update, index) => (
                <div key={update.id} className="relative pl-20">
                  {/* Timeline Dot */}
                  <div className="absolute left-5 top-6 w-6 h-6 rounded-full bg-gradient-to-br from-purple-primary to-green-primary flex items-center justify-center shadow-lg shadow-purple-primary/50">
                    <div className="w-3 h-3 rounded-full bg-white"></div>
                  </div>

                  {/* Update Card */}
                  <div className="bg-dark-secondary border border-purple-primary/20 rounded-2xl p-8 hover:border-purple-light/50 transition-all duration-300 hover:shadow-xl hover:shadow-purple-primary/20">
                    <div className="flex flex-wrap items-center gap-4 mb-4">
                      <Badge className="bg-gradient-to-r from-purple-primary to-purple-light text-white font-bold text-sm px-4 py-1">
                        {update.version}
                      </Badge>
                      <div className="flex items-center gap-2 text-gray-400 text-sm font-hero">
                        <Calendar size={16} />
                        <span>{update.date}</span>
                      </div>
                    </div>

                    <h2 className="text-2xl font-archive text-white mb-6">
                      {update.title}
                    </h2>

                    <div className="grid sm:grid-cols-2 gap-4">
                      {update.changes.map((change, idx) => (
                        <div 
                          key={idx} 
                          className="flex items-start gap-3 text-gray-300 font-hero bg-dark-primary/50 p-4 rounded-xl"
                        >
                          <CheckCircle2 className="text-green-primary mt-0.5 flex-shrink-0" size={18} />
                          <span className="text-sm leading-relaxed">{change}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
